// extracted by mini-css-extract-plugin
module.exports = {"block":"block___S4-cg","btn":"btn___2IPQb"};